import { AppContext } from "AppProvider/AppContext";
import React, { useContext, useState } from "react";
import { appRequest } from "routes";
import { combineValues } from "../function";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  Text,
} from "@chakra-ui/react";
import {
  handleSaveData,
  transformData
} from "../PRYViewer/component/utils/functions";
import { transformToinitialOrgAndEditedFormat } from "../fields/utils/functions";

type ModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
    }>
  >;
  handleGet: () => void;
  view: boolean;
  handleCloseModal?: any;
  editedValues?: any;
  isMulti?: boolean;
  isTable?: boolean;
};

export default function AddComentModal({
  isOpen,
  onClose,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
  handleCloseModal,
  view,
  editedValues,
  isMulti,
  isTable,
}: ModalProps) {
  const [submitLoader, setSubmitLoader] = useState(false);
  const { toastNotify } = useContext(AppContext);
  const { accountDetails, workFlowData } = useContext(AppContext);

  function transformObject(inputObject: any) {
    const transformedObject: any = {};
    for (const key in inputObject) {
      transformedObject[key] = {
        originalValue: inputObject[key],
        editFieldValue: null,
      };
    }
    return transformedObject;
  }

  const handleSubmitMultipleData = async () => {
    try {
      setSubmitLoader(true);
      const promises = selectedRows.map(async (row) => {
        if (
          !Array.isArray(row.values) &&
          isMulti &&
          workFlowData?.fileViewer?.approvalModalOption === "mdm"
        ) {
          if (Array.isArray(row?.values?.values?.results)) {
            row.values.values = handleSaveData(
              transformData(row?.values?.values?.results)
            );
          }
        }

        if (
          !Array.isArray(row?.values?.values) &&
          isMulti &&
          workFlowData?.fileViewer?.approvalModalOption === "fields"
        ) {
          if (Array.isArray(row?.values?.values?.results)) {
            const transformed = row?.values?.values?.results.map((result: any) => {
              return transformToinitialOrgAndEditedFormat(result?.fields);
            });

            row.values.values = {results : transformed};
          }
        }

        try {
          let valus = null;
          if (isMulti) {
            valus = Array.isArray(row.values)
              ? row?.values?.[row.values?.length - 1]?.values
              : row?.values?.values;
          } else {
            if (process.env.REACT_APP_CUREBAY === "true") {
              valus = editedValues;
            } else {
              if (isTable) {
                valus = Array.isArray(row.values)
                  ? row?.values?.[row.values?.length - 1]?.values
                  : row?.values?.values;
              } else {
                valus = combineValues(
                  Array.isArray(row.values)
                    ? row.values
                    : transformObject(row.values?.values),
                  editedValues
                );
              }
            }
          }

          const updatedStatus = {
            id: row._id,
            level: accountDetails.level,
            status: commentModel.selectedStatus,
            comment: commentModel.comment,
            values: valus,
            type: "document",
            activeWorkflow: workFlowData._id,
          };
          const response: any = await appRequest(
            "document",
            "update",
            updatedStatus
          );

          console.log('the response are', response)

          if (response.status !== "success") {

            throw new Error(response?.message || `Failed to update document for row`);
          }
        } catch (error: any) {
          return {
            title: "Error",
            message: error.message,
            type: "error",
          };
        }
      });

      let notifications: any = await Promise.all(promises);

      notifications = notifications.filter((not: any) => not?.type === "error");

      if (notifications.length) {
        notifications.forEach((notification: any) =>
          toastNotify({
            type: "error",
            title: notification.message,
          })
        );
      } else {
        toastNotify({
          type: "success",
          title: "Updates submitted",
          message: "Updated successfully.",
        });
        setSelectedRows([]);
        setCommentModel({
          open: false,
          comment: "",
          selectedStatus: "approved",
        });
        if (handleCloseModal) {
          handleCloseModal();
        }
      }
    } catch (err) {
      console.error(err);
      toastNotify({
        title: "Error",
        message: "Failed to update document.",
        type: "error",
      });
    } finally {
      handleGet();
      setSubmitLoader(false);
    }
  };

  return (
    <Modal
      isOpen={commentModel.open}
      onClose={() => {
        setSelectedRows([]);
        setCommentModel({
          selectedStatus: "approved",
          open: false,
          comment: "",
        });
      }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          color="teal.300"
          fontSize={{ base: "lg", md: "2xl" }}
          fontWeight="700"
          borderBottom="1px solid"
          borderColor="gray.200"
          pb={2}
        >
          Comment
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Textarea
            mt={4}
            value={commentModel.comment}
            onChange={(e: any) =>
              setCommentModel({ ...commentModel, comment: e.target.value })
            }
            placeholder="Type your comment here..."
            //   mb={2}
          />
        </ModalBody>
        <ModalFooter>
          <Flex justify="flex-end">
            <Button
              fontSize="sm"
              w="5rem"
              bg="green.400"
              _hover={{ bg: "green.500" }}
              color="white"
              mr={3}
              isLoading={submitLoader}
              onClick={() => {
                if (
                  // commentModel &&
                  (commentModel.selectedStatus === "rejected" || commentModel.selectedStatus === "approved") &&
                  // commentModel.comment &&
                  commentModel.comment.trim() === ""
                ) {
                  toastNotify({
                    type: "error",
                    message: "Please add a comment before approving or rejecting.",
                  });
                } else {
                  handleSubmitMultipleData();
                }
              }}
            >
              <Text>Yes</Text>
            </Button>
            <Button
              w="5rem"
              colorScheme="red"
              fontSize="sm"
              onClick={() =>
                setCommentModel({
                  open: false,
                  comment: "",
                  selectedStatus: "approved",
                })
              }
            >
              No
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
